import React from 'react';
import { Skeleton } from 'antd';

export const ProfileSkeleton: React.FC = () => (
  <div style={{ padding: 16 }}>
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
      <Skeleton.Avatar active size={72} />
    </div>
    <Skeleton active paragraph={{ rows: 2 }} />
    <Skeleton active paragraph={{ rows: 3 }} style={{ marginTop: 16 }} />
    <Skeleton active paragraph={{ rows: 2 }} style={{ marginTop: 16 }} />
  </div>
);
